import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { AlertTriangle, FileText, Check } from 'lucide-react';
import FieldConfidenceBadge from './FieldConfidenceBadge';

export default function ConflictResolverCard({ conflict, onResolve }) {
  if (!conflict || !conflict.options) return null;

  return (
    <div className="border border-amber-200 bg-amber-50/50 rounded-lg p-4 space-y-3" data-testid={`conflict-card-${conflict.field_key}`}>
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-600" />
        <span className="font-medium text-sm text-amber-800">{conflict.field_label}</span>
        <Badge variant="outline" className="text-xs bg-amber-100 text-amber-700 border-amber-300">
          Conflict
        </Badge>
      </div>

      <div className="space-y-2">
        {conflict.options.map((opt) => (
          <div
            key={opt.option_id}
            className="flex items-center justify-between gap-3 p-2 bg-white rounded border border-gray-200 hover:border-blue-300 transition-colors"
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm font-mono truncate">{opt.display_value}</p>
              <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
                <FileText className="h-3 w-3" />
                <span>{opt.source_file} (p.{opt.source_page})</span>
                <FieldConfidenceBadge level={opt.confidence_level} score={opt.confidence_score} />
              </div>
            </div>
            <Button
              size="sm"
              variant="outline"
              onClick={() => onResolve(conflict.field_key, opt.value)}
              className="flex-shrink-0"
              data-testid={`resolve-${conflict.field_key}-${opt.option_id}`}
            >
              <Check className="h-3 w-3 mr-1" />
              Use
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
